<template>
  <b-modal v-model="show" :title="title">
    <div class="container-fluid">
      <div class="form-group">
        <label><span>#{{id}}</span> Бекор қилиш сабабини киритинг<span class="red">*</span></label>
        <textarea class="form-control" v-model="rejectReasonText">
        </textarea>
      </div>
    </div>
    <div slot="modal-footer">
      <button
          type="button"
          class="all-btn add-btn float-right ml-2"
          @click="rejectAppraisal()"
      >{{ $t("action.save") }}
      </button>
      <button
          type="button"
          class="all-btn delete-btn float-right"
          @click="rejectModalHide"
      >{{ $t("action.cancel") }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import bModal from "bootstrap-vue/es/components/modal/modal";

export default {
  name: "RejectReasonModal",
  props: {
    title: {
      type: String,
      default: ''
    },
    id: {
        type: Number,
        default: null
    }
  },
  components: {
    'b-modal': bModal,
  },
  data() {
    return {
      show: false,
      rejectReasonText: ''
    }
  },
  methods: {
    rejectAppraisal() {
      if (this.rejectReasonText) {
        this.$emit('handle-reject-save', this.rejectReasonText)
      } else {
        this.$swal({
          title: 'Хабар!',
          text: 'Бекор қилиш сабабини киритинг!',
          type: 'warning'
        });
      }

    },
    rejectModalHide() {
      this.show = false;
      this.$emit('handle-reject-cancel')
    }
  },
  created() {
    this.$eventBus.$on("showRejectReasonModal", (show) => {
      this.show = show
      this.rejectReasonText = ''
    })
  }
}
</script>

<style scoped>

</style>